import React from 'react';
import Navbar from '../../components/Navbar';
import Hero from '../Hero';
import HeroImg from '../../assets/ServicesImg/ConsultingHero.jpg';
import { Link } from "react-router-dom"
import BottomContent from '../../components/BottomContent';
import ScrollButton from "../../components/ScrollButton";
import Thank from '../../components/Thank';
import ContactButton from '../../components/ContactButton';
import DarkModeButton from '../../components/DarkModeButton';

// Import service images
import StrategyImg from '../../assets/ServicesImg/Strategy.png';
import ClientExperienceImg from '../../assets/ServicesImg/Client-Experience.png';
import DataEngineeringImg from '../../assets/ServicesImg/Data-Engineering.png';
import AppRationalizationImg from '../../assets/ServicesImg/App-Rationalization.png';
import InnovationImg from '../../assets/ServicesImg/Innovation.png';
import BusinessSectorImg from '../../assets/ServicesImg/Business-Sector.png';

export default function Consulting() {
  const HeroConsulting = {
    heading: 'Advisory & Consulting',
    subheading: 'Empowering Transformation with Strategic Insights',
    des: `At Vedalytics, our Advisory & Consulting services are designed to guide businesses through digital transformation and innovation. From enterprise strategy and architecture to client experience and program management, we offer comprehensive solutions to address complex business challenges across various sectors, including education, healthcare, BFSI, industrial automation, and gaming.`,
    img: HeroImg
  }

  const consultingServices = [
    {
      image: StrategyImg,
      heading: 'Enterprise Strategy, Architecture & Transformation',
      text: `Drive your organization towards success with our comprehensive strategy and transformation services. We design and implement robust enterprise architectures that align with your business goals, ensuring seamless digital transformation and operational efficiency.`,
     
    },
    {
      image: ClientExperienceImg,
      heading: 'Client Experience and Lifecycle Management',
      text: `Enhance customer satisfaction with our client experience and lifecycle management solutions. We help you build long-lasting relationships through personalized interactions, optimized customer journeys, and data-driven insights that foster loyalty and engagement.`,
      
    },
    {
      image: DataEngineeringImg,
      heading: 'Data Science, Engineering and Governance',
      text: `Leverage the full potential of your data with our data science, engineering, and governance practices. From building data pipelines and integrating analytics to establishing data governance frameworks, we ensure data accuracy, compliance, and actionable insights.`,
     
    },
    {
      image: AppRationalizationImg,
      heading: 'App Rationalization & Modernization',
      text: `Modernize your application portfolio with our rationalization and modernization services. We assess your existing applications, identify optimization opportunities, and upgrade them to align with modern technologies and best practices, reducing maintenance costs and increasing efficiency.`,
     
    },
    {
      image: InnovationImg,
      heading: 'Innovation and Program Management',
      text: `Navigate innovation with strategic program management services. Our experts plan, execute, and manage initiatives that foster innovation and drive growth while ensuring that your projects stay on track and within budget.`,
     
    },
    {
      image: BusinessSectorImg,
      heading: 'Business Sectors Expertise',
      text: `We have deep expertise across various business sectors, including Education, Healthcare, BFSI, Industrial Automation, and Gaming. Our consulting services are tailored to address industry-specific challenges and deliver impactful results.`,
      
    }
  ];
  return (
    <>
      <Navbar />
      <Hero
        heading={HeroConsulting.heading}
        subheading={HeroConsulting.subheading}
        des={HeroConsulting.des}
        img={HeroImg}
      />
      <div className="container mt-5 mb-5">
        {consultingServices.map((consultingServices, index) => (
          <div className="row mb-5 align-items-center" key={index}>
              {/* Image */}
            <div className={`col-12 col-md-6 d-flex justify-content-center ${index % 2 === 0 ? "order-1 order-md-1" : "order-1 order-md-2"}`}>
              <img
                className="img-fluid"
                loading='lazy'
                src={consultingServices.image}
                alt={consultingServices.heading}
                style={{
                  maxWidth: "250px",
                  maxHeight: "250px",
                  width: "100%",
                  height: "auto",
                  borderRadius: "50px"
                }}
              />
            </div>

            {/* Text */}
                <div className={`col-12 col-md-6 text-center text-md-start ${index % 2 === 0 ? "order-2 order-md-2" : "order-2 order-md-1"}`}>
                  <h2 style={{ color: "var(--heading_color)",marginTop:'10px' }}>{consultingServices.heading}</h2>
                  <p className="fs-5 text-muted">{consultingServices.text}</p>
                </div>
          </div>
        ))}
      </div>
      {/* Call to Action Section - Improved */}
      <section className='' >
        <div className="p-5 text-center" style={{ backgroundColor: '#3BB893' }} data-aos="fade-up" data-aos-anchor-placement="top-center">
          <h3 className='text-light'>Having Projects ?</h3>
          <p className='text-light'>Schedule a Free Demo and Start Business you always Dream.</p>
          <div className="button">
            <button className='btn'><Link style={{ textDecoration: 'none', color: 'green' }} to='/scheduledemo'>Schedule Demo</Link></button>
          </div>
        </div>
      </section>
      <Thank />
      <ContactButton />
      <BottomContent />
      <DarkModeButton />
      <ScrollButton/>
      {/* Custom CSS */}
      <style>{`
        .card {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          border-radius: 12px;
          background: var(--card_color);
          color: var(--heading_color);
        }
        .card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
        }
      `}</style>
      
    </>
  )
}
